import axios from 'src/app-axios';
import Constants from 'src/constants';

export const userprofile = {
  namespaced: true,
    state: {
      userDetails: {},
      userActivities: [],
      organizationSettings: [],
    },
    getters: {
      getUserDetails (state) {
        return state.userDetails;
      },
      getUserActivities (state) {
        return state.userActivities;
      },
      getOrganizationSettings (state) {
        return state.organizationSettings;
      },
    },
    actions: {
      async fetchUserDetails ({ dispatch, commit }) {
        const url = 'api/devices/app-users';
        try {
          const details = await axios.get(url);
          commit('setUserDetails', details.data);
          localStorage.setItem(
              'selectedOrganization',
              JSON.stringify(details.data.selected_organization),
            );
        } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting the user details.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
      async updateUserDetails ({ dispatch }, payload) {
        const url = 'api/devices/app-users/update';
        try {
          await axios.put(url, payload.details);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in updating your details.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
      async updateProfileImage ({ dispatch }, payload) {
        const url = `api/devices/app-users/${payload.appUserId}/upload`;
        try {
          await axios.post(url, payload.formData);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in updating your details.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
      async fetchUserActivities ({ dispatch, commit }, payload) {
        const url = 'api/devices/app-users/activity';
        try {
          const activities = await axios.get(url, payload.params);
          commit('setUserActivities', activities.data.data);
        } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting the user activity data.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
      async fetchFilteredActivities ({ dispatch, commit }, payload) {
        const url = 'api/devices/app-users/activity';
        try {
          const activities = await axios.get(url, payload);
          commit('setAppUserOrgCheckInActivities', activities.data.data);
        } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting the user activity data.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
      async fetchOrganizationSettings ({ dispatch, commit }) {
        const url = 'api/devices/organizations/modules';
        try {
          const modules = await axios.get(url);
          commit('setOrganizationSettings', modules.data);
        } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting the organization settings data.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
      async fetchAppUserOrgCheckInActivities ({ dispatch, commit }, payload) {
        const url = 'api/devices/app-users/activity';
        try {
          const activities = await axios.get(url, payload.params);
          commit('setAppUserOrgCheckInActivities', activities.data.data);
        } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting the check-in activity',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
      async updateTimezone ({ dispatch }, payload) {
        const url = 'api/devices/app-users/timezone';
        try {
          await axios.put(url, payload.params);
        } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in updating timezone',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
      clearUserActivities ({ commit }) {
        commit('clearUserActivityDatas');
      },
    },
    mutations: {
      setUserDetails (state, details) {
        state.userDetails = details;
      },
      setUserActivities (state, activities) {
        state.userActivities = [...state.userActivities, ...activities];
      },
      setAppUserOrgCheckInActivities (state, activities) {
        state.userActivities = activities;
      },
      setOrganizationSettings (state, modules) {
        state.organizationSettings = modules;
      },
      clearUserActivityDatas (state) {
        state.userActivities = [];
      },
    },
};
